import { VehicleVersionQuotes } from '../models/vehicle-version-quotes';

export class InfocarQuotazioniVersione {
  chilometriTeorici: number;
  listinoNuovo: number;
  quotazioneVendita: number;

  static infocarQuotazioniVersioneToVehicleVersionQuotesDto(infocarQuotazioniVersione: InfocarQuotazioniVersione): VehicleVersionQuotes {
    let result = new VehicleVersionQuotes();
    result.theoreticalKilometers = infocarQuotazioniVersione.chilometriTeorici;
    result.newPriceList = infocarQuotazioniVersione.listinoNuovo;
    result.sellVehicleQuote = infocarQuotazioniVersione.quotazioneVendita;
    return result;
  }
}
